
import { Generic } from "./generic";

export class Solicitante extends Generic {
    id: string;
    dssolicitante: string;
    dtatualizacao: string;
}